import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import componentLibraryManifest from '@deliveroo/consumer-component-library/manifest';
import withI18n from '../components/withI18n';
import ErrorPageContent from '../components/ErrorPageContent';
import sentry from '../utils/sentry';

import styles from '../containers/Page/styles.scss';

const { captureException } = sentry();

class Error extends React.Component {
  static getInitialProps(ctx) {
    const { res, err, jsonPageRes } = ctx;

    if (err && res.statusCode !== 404) {
      // `err` isn't present if `renderError` has been called from the express.js
      // error handler in server.js, which has already tracked to Sentry
      captureException(err);
    }

    let statusCode;
    if (res) {
      statusCode = res.statusCode;
    } else {
      statusCode = jsonPageRes ? jsonPageRes.status : 500;
    }

    return { statusCode };
  }

  render() {
    const isError = this.props.statusCode >= 500;
    const title = isError ? 'Something went wrong' : 'Page Not Found';

    return (
      <Fragment>
        <Head>
          <title>{title}</title>

          <link
            rel="stylesheet"
            type="text/css"
            href={componentLibraryManifest['consumer-component-library.css']}
          />
        </Head>
        <div className={styles.page}>
          <ErrorPageContent isError={isError} title={title}>
            {this.props.children}
          </ErrorPageContent>
        </div>
      </Fragment>
    );
  }
}

Error.propTypes = {
  statusCode: PropTypes.number.isRequired,
  children: PropTypes.node,
};

Error.defaultProps = {
  children: undefined,
};

export default withI18n(Error);
